import type {RecommendedTemplatesData} from '@/ai-chat/ai-chat.types';

export const getRecommendedDesignTemplates = async (searchTags: string[]): Promise<RecommendedTemplatesData> => {
  return (await window.PMW.readLocal('ai/getRecommendedDesignTemplates', {
    searchTags,
  })) as RecommendedTemplatesData;
};

